import { useEffect, useMemo, useState } from "react";
import api from "../../services/api";
import Param from "../../models/Param";

interface Params {
  afterSelect: (id: number) => void;
  selectedId?: number;
  id?: string;
  name?: string;
  label?: string;
  emptyOptionLabel?: string;
  wrapperClassName?: string;
  selectWrapperClassName?: string;
}

const CongregationSelect = ({
  afterSelect,
  selectedId,
  id = "congregation",
  name = "congregation",
  label = "Congregação",
  emptyOptionLabel = "Todas",
  wrapperClassName = "uk-width-1-1@m",
  selectWrapperClassName = "uk-width-1-2@m"
}: Params) => {
  const [congregations, setCongregations] = useState<Param[]>([]);
  const [congSearch, setCongSearch] = useState<number>(selectedId ?? 0);

  useEffect(() => {
    setCongSearch(selectedId ?? 0);
  }, [selectedId]);

  const selectedLabel = useMemo(() => {
    if (!congSearch) {
      return emptyOptionLabel;
    }

    return congregations.find((item) => item.id === congSearch)?.description ?? emptyOptionLabel;
  }, [congSearch, congregations, emptyOptionLabel]);

  useEffect(() => {
    const init = async () => {
      const { data } = await api.get("congregations/dashboard");
      setCongregations(data);
    };
    
    init();
  }, []);

  return <div className={wrapperClassName}>
      <label
        className="uk-form-label uk-margin-right"
        htmlFor={id}
      >
        {label}
      </label>
      <div
        uk-form-custom="target: > * > span:first-child"
        className={selectWrapperClassName}
      >
        <select
          className="uk-form-small"
          id={id}
          name={name}
          value={congSearch}
          onChange={(e) => { setCongSearch(+e.target.value); afterSelect(+e.target.value); }}
        >
          <option value={0} key={`congregation0`}>
            {emptyOptionLabel}
          </option>
          {congregations.map((f) => {
            return (
              <option value={f.id} key={`congregation${f.id}`}>
                {f.description}
              </option>
            );
          })}
        </select>
        <button
          className="uk-button uk-button-default uk-button-select uk-form-small uk-width-1 uk-flex uk-flex-middle uk-flex-between"
          style={{ textTransform: "none" }}
          type="button"
          tabIndex={-1}
        >
          <span>{selectedLabel}</span>
          <span uk-icon="icon: chevron-down"></span>
        </button>
      </div>
    </div>
};

export default CongregationSelect;